export default __webpack_public_path__ + "static/media/0002.ac0e4a64.jpg";